import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';

import { ComplementaryMaterialForm } from './ComplementaryMaterialForm';
import { ComplementaryMaterialSectionItem } from './ComplementaryMaterialSectionItem';
import { Wrapper } from './ComplementaryMaterialSections.styles';

import { ActivityPreview } from '@/components/ActivityPreview';
import { useCourseDetail } from '@/store';

export const ComplementaryMaterialSections = () => {
  const { t } = useTranslation('CourseTranslations');
  const { course } = useCourseDetail();

  if (!course) return null;

  const { complementaryMaterial } = course;

  return (
    <Wrapper>
      {!complementaryMaterial?.sections?.length && (
        <Empty description={t('COURSE_WITH_NO_SECTIONS')} />
      )}
      {complementaryMaterial?.sections?.map(section => (
        <ComplementaryMaterialSectionItem key={section._id} section={section} />
      ))}
      <ComplementaryMaterialForm />
      <ActivityPreview />
    </Wrapper>
  );
};
